module.exports = __webpack_public_path__ + "static/img/F01-合肥包河区协和双语学校.f2cd7dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/F01-合肥包河区协和双语学校.png
// module id = Xa2N
// module chunks = 0